<template>
    <div class="flex flex-col my-8 relative mx-auto w-5/6 md:flex-row my-32 w-3/6">
      <div id="imagecontainer" @mouseenter="imageSwitch(true)" @mouseleave="imageSwitch(true)" @click="imageSwitch(false)" class="w-5/6 h-full mx-auto md:w-2/5" style="height:45vh">
        <img v-show="!imageswitch" :src="url + object.image1.url"/>
        <img v-show="imageswitch" :src="url + object.image2.url"/>
      </div>
      <div id="meta" class="w-full md:w-3/6 mt-4 flex flex-col justify-center text-left">
        <div v-if="object.name"><span id="t">{{ object.name }}</span> <span v-if="object.information" id="m">{{ object.information }}</span></div><br>
        <div v-if="object.dimensions"><span id="m">Dimensions  | </span> {{ object.dimensions }}</div>
        <div v-if="object.edition"><span id="m">Edition  | </span> {{ object.edition }}</div>
        <div v-for="label in object.Store_label" :key="label.id">
          <span id="m">{{ label.label_text }}  | </span> {{ label.label_content }}
        </div>
        <router-link :to="`/work/${object.project.title}`" :project="project">
          Click here to see more.
        </router-link>
      </div>
    </div> 
</template>

<script>
export default {
  name: "StoreObjectContainer",
  data() {
    return {
      url: process.env.VUE_APP_VPS_URL,
      imageswitch: false
    }
  },
  props: ['object', 'isMobile'],
  methods: {
    imageSwitch(prevent) {
      if (this.isMobile) {
        if (prevent == false) {
          if (this.imageswitch == false) {
            this.imageswitch = true;
          } else {
            this.imageswitch = false;
          }
        }
      } else {
          if (this.imageswitch == false) {
          this.imageswitch = true;
        } else {
          this.imageswitch = false;
        }
      }
    }
  }

}
</script>

<style scoped>
img {
  object-fit: contain;
  width: 100%;
  height: 100%;
  object-position: 50% 50%;
}

#m {
  font-family: L;
  font-weight: 900;
  font-size:17px;
  text-transform: uppercase;
}
</style>